import { EnemyAct, SimConstants } from "@highmarch/domain";
import type { BalanceData, Enemy, EnemyArchetype } from "@highmarch/domain";

/**
 * What the M21 enemies do (docs/ENEMIES_V2.md), in short lines read off their numbers (enemies.json → abilities), for
 * the enemy info card and the Almanac. Pure and DOM-free; an archetype without an ability has no lines.
 */
const PERCENT = 100;
const seconds = (ticks: number): string => { const s = ticks / SimConstants.TicksPerSecond; return Number.isInteger(s) ? String(s) : s.toFixed(1); };
const cells = (n: { toNumber(): number }): string => { const c = n.toNumber(); return Number.isInteger(c) ? String(c) : c.toFixed(1); };

export function enemyTraitLines(B: BalanceData, a: EnemyArchetype): string[] {
  const k = a.abilities, out: string[] = [];
  if (k.summonEnemy >= 0) {
    out.push(`Stops every ${seconds(k.summonIntervalTicks)} s to call ${k.summonCount} ${B.enemies[k.summonEnemy].name}s · ${k.summonCap} at most`);
  }
  if (k.burrowDistance.isPositive()) {
    out.push(`When hit, it digs ${cells(k.burrowDistance)} cells under the road, out of reach · ${k.burrowMax} dives`);
    out.push("Soldiers who hold it stop it digging");
  }
  if (k.magicTaken.toNumber() < 1) out.push(`Takes ${Math.round((1 - k.magicTaken.toNumber()) * PERCENT)}% less magic damage`);
  if (k.noAffix) out.push("Never an elite");
  if (k.stompRadius.isPositive()) {
    out.push(`Stomps every ${seconds(k.stompIntervalTicks)} s: towers within ${cells(k.stompRadius)} cells are stunned for ${seconds(k.stompDisableTicks)} s`);
  }
  return out;
}

/** What a live enemy is doing now, when an ability has it: "underground", "casting", "winding up", or "". */
export function enemyActLabel(e: Enemy): string {
  switch (e.act) {
    case EnemyAct.Burrowed: return "underground";
    case EnemyAct.Digging: return "digging in";
    case EnemyAct.Surfacing: return "surfacing";
    case EnemyAct.Summoning: return "casting";
    case EnemyAct.WindingUp: return "winding up";
    default: return "";
  }
}
